
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/all-products",
      function () {
        return require("private-next-pages/all-products/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/all-products"])
      });
    }
  